// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Cp-z","play":"Dp-z"};